import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { ApiGroupUserHelperService } from './group-user-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiGroupUserService {
  constructor(
    public helper: ApiGroupUserHelperService,
    private _api: ApiService
  ) {}

  get(id: number | string) {
    return this._api.get('group-user/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('group-user/list', data);
  }

  create(data: any) {
    return this._api.post('group-user/create', data);
  }

  update(data: any) {
    return this._api.post('group-user/update', data);
  }

  remove(id: number) {
    return this._api.post('group-user/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(
        text !== null
          ? { ...data, text }
          : { ids: Array.isArray(id) ? id : [id] }
      ).pipe(
        map((result) =>
          result.data.map((item: any) => {
            return {
              id: item.id,
              label: item.name,
              data: item,
            };
          })
        )
      );
    };
  }
}
